// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uploader {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  gap: 20px;
}
.uploader .thumbnail {
  position: relative;
  height: 100%;
  width: 100%;
  max-width: 120px;
  max-height: 120px;
  aspect-ratio: 1/1;
}
.uploader .thumbnail.hidden {
  display: none;
}
.uploader .thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.uploader .thumbnail .close, .uploader .thumbnail .open {
  position: absolute;
  top: 0px;
  right: 0px;
  text-align: center;
  line-height: 20px;
  width: 20px;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.8);
}
.uploader .thumbnail .open {
  right: 20px;
}
.uploader .add-button {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  max-height: 120px;
  aspect-ratio: 1/1;
  color: gray;
  font-size: 40px;
  border: 1px dashed gray;
  cursor: pointer;
}
.uploader .add-button .plus {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.uploader .add-button input {
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
@keyframes placeHolderShimmer {
  0% {
    background-position: -50% 0;
  }
  100% {
    background-position: 50% 0;
  }
}
.uploader .loading {
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background-color: #f6f7f8;
  background: linear-gradient(to right, #eeeeee 8%, #bbbbbb 18%, #eeeeee 33%);
  background-size: 400px 100%;
  height: 100%;
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/components/Forms/Uploader/Uploader.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;AACJ;AACI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AACR;AACQ;EACI,aAAA;AACZ;AAEQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAAZ;AAGQ;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,oCAAA;AADZ;AAIQ;EACI,WAAA;AAFZ;AAMI;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;EACA,uBAAA;EACA,eAAA;AAJR;AAMQ;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AAJZ;AAOQ;EACI,UAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AALZ;AASI;EACI;IACI,2BAAA;EAPV;EASM;IACI,0BAAA;EAPV;AACF;AAUI;EACI,sBAAA;EACA,6BAAA;EACA,mCAAA;EACA,kCAAA;EACA,iCAAA;EACA,yBAAA;EACA,2EAAA;EACA,2BAAA;EACA,YAAA;EACA,kBAAA;AARR","sourcesContent":[".uploader {\r\n    display: flex;\r\n    flex-direction: row;\r\n    flex-wrap: wrap;\r\n    width: 100%;\r\n    gap: 20px;\r\n\r\n    .thumbnail {\r\n        position: relative;\r\n        height: 100%;\r\n        width: 100%;\r\n        max-width: 120px;\r\n        max-height: 120px;\r\n        aspect-ratio: 1/1;\r\n\r\n        &.hidden {\r\n            display: none;\r\n        }\r\n\r\n        img {\r\n            width: 100%;\r\n            height: 100%;\r\n            object-fit: cover;\r\n        }\r\n\r\n        .close, .open {\r\n            position: absolute;\r\n            top: 0px;\r\n            right: 0px;\r\n            text-align: center;\r\n            line-height: 20px;\r\n            width: 20px;\r\n            font-weight: bold;\r\n            font-size: 16px;\r\n            cursor: pointer;\r\n            background: rgba(255, 255, 255, 0.8);\r\n        }\r\n\r\n        .open {\r\n            right: 20px;\r\n        }\r\n    }\r\n\r\n    .add-button {\r\n        position: relative;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        height: 100%;\r\n        max-height: 120px;\r\n        aspect-ratio: 1/1;\r\n        color: gray;\r\n        font-size: 40px;\r\n        border: 1px dashed gray;\r\n        cursor: pointer;\r\n\r\n        .plus {\r\n            position: absolute;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            width: 100%;\r\n            height: 100%;\r\n        }\r\n\r\n        input {\r\n            opacity: 0;\r\n            width: 100%;\r\n            height: 100%;\r\n            cursor: pointer;\r\n        }\r\n    }\r\n\r\n    @keyframes placeHolderShimmer {\r\n        0% {\r\n            background-position: -50% 0;\r\n        }\r\n        100% {\r\n            background-position: 50% 0;\r\n        }\r\n    }\r\n\r\n    .loading {\r\n        animation-duration: 1s;\r\n        animation-fill-mode: forwards;\r\n        animation-iteration-count: infinite;\r\n        animation-name: placeHolderShimmer;\r\n        animation-timing-function: linear;\r\n        background-color: #f6f7f8;\r\n        background: linear-gradient(to right, #eeeeee 8%, #bbbbbb 18%, #eeeeee 33%);\r\n        background-size: 400px 100%;\r\n        height: 100%;\r\n        position: relative;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
